export const RESET = 'EXCMAGREEMENTCONSENT_UPDATE_RESET'
export const SET_ERROR = 'EXCMAGREEMENTCONSENT_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMAGREEMENTCONSENT_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMAGREEMENTCONSENT_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMAGREEMENTCONSENT_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMAGREEMENTCONSENT_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMAGREEMENTCONSENT_UPDATE_UPDATE_RETRIEVED'
